<app-batter *ngIf="broadcast?.lowerThird?.seasonStats" [broadcast]="broadcast" [player]="broadcast.lowerThird" [controlAction]="controlAction"></app-batter>
<div *ngIf="!broadcast?.lowerThird?.seasonStats" class="component-container player-stats"
     [class]="controlAction"
     [class.odm-away]="utilservice.getTeamSide(broadcast?.lowerThird?.teamGuid, broadcast) === 'away'"
     [class.odm-home]="utilservice.getTeamSide(broadcast?.lowerThird?.teamGuid, broadcast) === 'home'">
  <div class="image"
       [style.background-color]="getTeamBgr()"
  >
    <div class="team-img" [style]="getBgrWithOverlay()">
      <span class="team-code" *ngIf="utilservice.hideTeamLogos(broadcast)">{{utilservice.getTeamShortCode(broadcast?.lowerThird?.teamGuid, broadcast)}}</span>
    </div>
  </div>
  <div class="stats">
    <div class="name"
         [style.background-color]="getTeamBgr()">
      <div>{{getNumber()}} {{getName().toUpperCase()}}</div>
      <div class="position" *ngIf="broadcast?.lowerThird?.position">
        {{utilservice.positionToString(broadcast?.lowerThird?.position)}}
      </div>
    </div>
    <div class="data">
      {{broadcast?.lowerThird?.info}}
    </div>
  </div>
</div>
